export default __webpack_public_path__ + "static/EcomChair-f4513263263dc5a6f4cfc1b35b824f90.webm";